module.exports = __webpack_public_path__ + "static/media/02_BOJO_MEIA_TACA_LISO_07.371876a4.jpg";